<template>
	<div
		class="article_list"
		:style="{ '--padding-top': paddingTop, '--padding-bottom': paddingBottom }"
	>
		<div class="container">
			<div
				class="inner"
				:class="{ top_border: showTopBorder === 'yes' }"
			>
				<h2
					v-if="title"
					v-html="title"
				></h2>
				<article-list-item
					v-for="(article, index) in JSON.parse(articles)"
					:key="index"
					:title="article.title ? article.title : 'No title'"
					:image="
            article.featured_image.large
              ? article.featured_image.large
              : article.featured_image"
					:text="article.excerpt ? article.excerpt : 'No excerpt'"
					:link="article.permalink ? article.permalink : 'No permalink'"
				></article-list-item>
			</div>
		</div>
	</div>
</template>

<script>
// import axios from 'axios';
import ArticleListItem from '../vue/ArticleListItem.vue';

export default {
	data() {
		return {};
	},

	props: {
		articles: {},
		title: {
			default: null,
		},
		showTopBorder: {
			default: 'no',
		},
		paddingTop: {
			default: '80px',
		},
		paddingBottom: {
			default: '80px',
		},
	},

	computed: {},

	watch: {},

	methods: {
		stripped(arg) {
			return arg.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, '');
		},
	},

	components: {
		ArticleListItem,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.article_list {
	.inner {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: $spacer * 2;
		padding: var(--padding-top) 0 var(--padding-bottom);

		@media (max-width: $lg) {
			grid-template-columns: 1fr;
			padding: 0 0 $spacer * 2;
			gap: $spacer;
		}

		&.top_border {
			border-top: 1px solid $cpmec-blue;
			padding-top: $spacer * 2;
		}

		h2 {
			grid-column: span 3;
			margin: 0;
			color: $cpmec-blue;
			font-family: $font-family;
			font-size: 36px;
			font-weight: normal;

			@media (max-width: $lg) {
				grid-column: span 1;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ArticleList.vue